import React from "react";
import { Button } from "@/shared/components/ui/Button";
import { useModal } from "@/shared/contexts/ModalProvider";
import FullCoverageDetailsContent from "@/shared/components/FullCoverageDetailsModal";
import Strings from "../utils/Strings.constants";
import { cn } from "../utils";
import { Pet } from "../types/Quote.interface";
import { useThemeContext } from "../contexts/ThemeProvider";
import { WaitingPeriods } from "@/shared/components/FullCoverageDetailsModal/coverageData";

interface ExclusionProps {
    activePet?: Pet;
    policies?: Pet[];
    showTelehealth?: boolean;
    samplePolicyUrl?: string;
    preExistingConditions: string;
    waitingPeriods?: WaitingPeriods;
    isDentalCovered?: boolean;
    isMicrochippingCovered?: boolean;
    showCompellingStats?: boolean;
    showBreedSpecificConditions?: boolean;
    hasAnyBreedConditions?: boolean;
}

const Exclusions = (props: ExclusionProps) => {
    const { activePet, policies, ...restProps } = props;
    const { showModal } = useModal();
    const { showRebrandTheme } = useThemeContext().theme;
    const textColorClass = {
        "text-content-primary": showRebrandTheme
    };

    return (
        <div className={cn("mt-3 flex flex-col gap-1 rounded-md bg-background-brand-b-secondary p-4 sm:mx-auto md:items-center")}>
            <h4 className={cn("text-sm font-bold text-content-brand-b", textColorClass)}>What isn’t covered under Spot plans?</h4>
            <div className={cn("text-xs text-content-brand-b", textColorClass)}>
                Pre-existing conditions, breeding/pregnancy care, & cosmetic surgeries.
                {/* <span> */}
                <Button
                    onClick={() =>
                        showModal(
                            "exclusions-modal",
                            <FullCoverageDetailsContent {...restProps} activePet={activePet} policies={policies} initialTab="notCovered" />,
                            Strings.COVERAGE_DETAILS
                        )
                    }
                    className={cn("px-2 text-xs font-bold text-content-brand-b underline", textColorClass)}
                    variant="ghost"
                    size="sm"
                >
                    {Strings.EXCLUSIONS_MODAL_CTA}
                </Button>
                {/* </span> */}
            </div>
        </div>
    );
};

export default Exclusions;
